import type { LegacyRef } from 'react';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import type { NavItemProps } from './NavItemComponent';
import NavItemComponent from './NavItemComponent';
import { ApiItemType } from '@highimpact-frontend/api-types';

export interface NavButtonProps extends NavItemProps {
  url: string;
  name: string;
  itemName?: ApiItemType;
  icon?: string | null;
  mode?: '' | 'danger';
  active?: boolean;
}

function NavButtonComponent(
  { url, name, icon = null, mode = '', active, itemName, ...props }: NavButtonProps,
  ref: LegacyRef<HTMLLIElement>
) {
  return (
    <NavItemComponent
      ref={ref}
      {...props}
      active={active}
      className={`nav-button ${props.className || ''} ${mode}`}
    >
      <Link
        to={url}
        className={`uk-link-reset`}
        target={url.includes('http') ? '_blank' : '_self'}
      >
        <div>
          {icon !== null && <span uk-icon={icon}></span>}
          {name}
        </div>
      </Link>
    </NavItemComponent>
  );
}

export default forwardRef(NavButtonComponent);
